
import Base from '@/shared/app/ui/Base.vue';
import { encode } from 'html-entities';
import Component from 'vue-class-component';
import type CSS from 'csstype';

@Component
export default class TextArea extends Base {
  get textStyle(): CSS.Properties {
    const config = this.config as CSS.Properties;

    const style: CSS.Properties = {
      fontSize: config.fontSize || 'inherit',
      fontFamily: config.fontFamily || 'sans-serif',
      fontWeight: config.fontWeight || 'normal',
      fontStyle: config.fontStyle || 'normal',
      color: config.color || 'inherit',
      textAlign: config.textAlign || 'left',
      lineHeight: config.lineHeight || 'inherit',
      padding: config.padding || '0',
      justifyContent: config.justifyContent || 'flex-start',
    };

    return style;
  }

  get datasetName() {
    return this.config.datasetName?.toString() || 'data';
  }

  get keyName() {
    return this.config.textDatasetKeyName?.toString() || 'text';
  }

  get content() {
    let baseContent =
      this.config.text?.toString() ||
      this.dataset(this.datasetName)[this.keyName]?.toString() ||
      this.config.defaultText?.toString() ||
      '';
    baseContent = encode(baseContent);
    baseContent = baseContent.replace(/\*(\S.*\S)\*/g, '<strong>$1</strong>');
    baseContent = baseContent.replace(/\n/g, '<br />');
    return baseContent;
  }
}
